import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/AuctionFeaturePages/Home/Home';
import Login from './pages/AuctionFeaturePages/Authentication/Login';
import Register from './pages/AuctionFeaturePages/Authentication/Register';
import AdminDashboardPage from './pages/AuctionFeaturePages/Admin/AdminDashboardPage';
import AdminDashboardWithSidebar from './components/AuctionFeatureComponents/Admin/AdminDashboard/AdminDashboardNavbar';
import Profile from './components/AuctionFeatureComponents/Admin/AdminDashboard/AdminDashboardProfile';
import LiveBiddingRoutes from './pages/AuctionFeaturePages/Bidding/LiveBiddingPage';
import AuctionsPage from './pages/AuctionFeaturePages/UserView/AuctionPage';
import About from './pages/AuctionFeaturePages/Home/About';
import HowToUse from './pages/AuctionFeaturePages/Home/HowToUse';
import PrivacyPolicy from './pages/AuctionFeaturePages/Home/PrivacyPolicy';
import TermsOfService from './pages/AuctionFeaturePages/Home/TermsOfService';
import AuctionDetailsInSidebar from './components/AuctionFeatureComponents/Admin/AdminDashboard/AuctionDetailsInSidebar';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/about" element={<About />} />
    <Route path="/how-to-use" element={<HowToUse />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/terms-of-service" element={<TermsOfService />} />
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/auctions" element={<AuctionsPage />} />
    <Route path="/admin-dashboard/*" element={<AdminDashboardWithSidebar />}>
      <Route path="" element={<AdminDashboardPage />} />
      <Route path="profile" element={<Profile />} />
      <Route path="auction/:auctionId" element={<AuctionDetailsInSidebar />} />
    </Route>
    <Route
      path="/live-auction/:auctionId/*"
      element={
          <LiveBiddingRoutes />
      }
    />
  </Routes>
);

export default AppRoutes;